import React from "react";
import './styles.css'
import minusIcon from '../../assets/images/minus-icon.svg';
import plusIcon from '../../assets/images/plus-icon.svg';
export class Perguntas extends React.Component {
    constructor() {
        super();
        this.state = { active: false };
    };

    toggleClass = () => {
        this.setState({ active: !this.state.active });
    };

    render() {
        const { active } = this.state;

        return (
            <>
                <div onClick={this.toggleClass} className={active ? 'container-duvidas__sanfona active' : 'container-duvidas__sanfona'}>
                    <div className="duvidas__sanfona">

                        <h3 className="duvidas__sanfona-titulo">{this.props.tituloSanfona}</h3>

                        <img className="" src={active ? minusIcon : plusIcon} alt="" />
                    </div>
                    <div className="container-conteudo">
                        <p className={active ? 'conteudo active' : 'conteudo'}>{this.props.duvidasResposta}</p>
                    </div>
                </div>
            </>
        );
    }
}